<template>
  <div v-show="show" style="background-color: white;">
    <b-container fluid style="margin-top: -24px; padding: 0 15px;">
      <b-row ref="category" class="text-center" align-v="start" :style="'line-height: ' + categoryHeight + 'px; background-color: #29363d; color: aliceblue; width: 100%; position: fixed; z-index: 50;'">
        <b-col sm="2" />
        <b-col v-for="(item, index) in categories" :key="index">
          <div :class="'category ' + item.extraClass" @click="changeTo(index)">
            <span><i :class="item.icon" /> {{ item.name }}</span>
          </div>
        </b-col>
        <b-col sm="2" />
      </b-row>
    </b-container>
    <b-container fluid :style="'padding-top: ' + categoryHeight + 'px'">
      <b-row class="justify-content-md-center">
        <h2 :ref="selectedCategory.code" class="categoryHead">{{ selectedCategory.name }}</h2>
      </b-row>
      <b-row>
        <b-col sm="2" />
        <b-col>
          <b-tabs
            v-if="changeSuccess"
            content-class="mt-3"
            fill
            active-nav-item-class="font-weight-bold text-primary"
            active-tab-class="font-weight-bold"
            ref="serviceTab"
          >
            <template v-for="(service, s_index) in selectedService">
              <b-tab :key="s_index" :title="service.name" :active="$route.params.initServiceCode ? service.code === $route.params.initServiceCode : s_index === 0" title-link-class="serviceHead">
                <b-form inline>
                  <h1 style="margin-right: 10px;">{{ service.name }}</h1>
                  <b-button :to="{name: 'welcome-demos', params: {categoryCode: selectedCategory.code , serviceCode: service.code}}" size="sm" variant="outline-primary">查看DEMO <i class="fa fa-angle-double-right" /></b-button>
                </b-form>
                <v-md-preview v-if="service.ismd" class="serviceBrief" :text="service.brief" />
                <div v-else v-html="service.brief" style="padding: 20px 12px !important;" />
              </b-tab>
            </template>
          </b-tabs>
        </b-col>
        <b-col sm="2" />
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'

export default {
  name: 'welcome-new',
  mixins: [Error],
  data () {
    return {
      items: {},
      categories: [],
      products: {},
      categoryHeight: 100,
      categoryClass: '',
      selectedCategory: {},
      selectedService: [],
      currentPage: 1,
      perPage: 100000,
      show: false,
      changeSuccess: true
    }
  },
  created () {
    this.$parent.$parent.extraStyle = 'padding: 0;'
    this.getCategories()
  },
  destroyed () {
    this.$parent.$parent.extraStyle = ''
  },
  methods: {
    getCategories () {
      api.fetchListData(this, api.getWelcomeCategoryList(), 'categorys', null, this.fetchCategoryCallback)
    },
    getAllServices () {
      api.fetchListData(this, api.getWelcomeServiceList(), 'services', null, this.fetchServiceCallback)
    },
    fetchCategoryCallback (data) {
      this.categories = data['categorys']
      this.getAllServices()
    },
    fetchServiceCallback (data) {
      const categoryCode = this.categories.map(i => i.code)
      data['services'].forEach((item) => {
        if (categoryCode.indexOf(item.category) !== -1) {
          if (this.items.hasOwnProperty(item.category)) {
            this.items[item.category].push(item)
          } else {
            this.items[item.category] = [item]
          }
        }
      })
      for (let idx = this.categories.length - 1; idx >= 0; idx--) {
        if (!this.items.hasOwnProperty(this.categories[idx].code)) {
          this.categories.splice(idx, 1)
        }
      }
      this.getSelectedItem(!!this.$route.params.initCategoryCode)
    },
    changeTo (idx) {
      this.changeSuccess = false
      delete this.$route.params.initServiceCode
      this.selectedCategory = this.categories[idx]
      this.selectedService = this.items[this.categories[idx].code]
      this.categories.forEach((item, index, arr) => {
        if (item.code === this.categories[idx].code) {
          arr[index].extraClass = 'active'
        } else {
          arr[index].extraClass = ''
        }
      })
      this.$nextTick(function () {
        this.changeSuccess = true
      })
    },
    getServices (category) {
      if (this.items && this.items[category]) {
        return this.items[category]
      }
      return []
    },
    getSelectedItem (byCode = false) {
      if (!byCode) {
        this.categories.forEach((item, index, arr) => {
          if (index === 0) {
            arr[index].extraClass = 'active'
            this.selectedCategory = arr[index]
          } else {
            arr[index].extraClass = ''
          }
        })
      } else {
        this.categories.forEach((item, index, arr) => {
          if (item.code === this.$route.params.initCategoryCode) {
            arr[index].extraClass = 'active'
            this.selectedCategory = arr[index]
          } else {
            arr[index].extraClass = ''
          }
        })
      }
      this.selectedService = this.items[this.selectedCategory.code]
      this.show = true
    }
  }
}
</script>

<style>
  .category {
    font-size: 18px;
    font-weight: bold;
  }
  .category.active {
    background-color: #F5E8C7;
    color: #29363d;
  }
  .category:hover {
    font-size: 21px;
  }
  .category.active:hover {
    font-size: 18px;
  }
  .categoryHead {
    line-height: 100px;
  }
  .serviceHead {
    font-size: 16px !important;
  }
  .serviceHead.active {
    border-color: #fff !important;
    border-bottom: 5px #20a8d8 solid !important;
  }
  .serviceHead:hover {
    border-color: #fff !important;
    font-weight: bolder !important;
  }
  .serviceHead.active:hover {
    border-bottom: 5px #20a8d8 solid !important;
  }
  .tab-content {
    border: none !important;
  }
  .serviceBrief .markdown-preview {
    overflow-y: hidden !important;
  }
  .font-weight-bold .v-md-editor-preview {
    font-weight: 500 !important;
  }
</style>



// WEBPACK FOOTER //
// WelcomeNew.vue?d6ff176e